/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Writing_Mode_Aria_LabelInputs */

const en_writing_mode_aria_label = /** @type {(inputs: Writing_Mode_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle writing mode between horizontal and vertical`)
};

const fr_writing_mode_aria_label = /** @type {(inputs: Writing_Mode_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer le mode d'ecriture entre horizontal et vertical`)
};

const de_writing_mode_aria_label = /** @type {(inputs: Writing_Mode_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreibmodus zwischen horizontal und vertikal umschalten`)
};

const it_writing_mode_aria_label = /** @type {(inputs: Writing_Mode_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterna la modalità di scrittura tra orizzontale e verticale`)
};

const ru_writing_mode_aria_label = /** @type {(inputs: Writing_Mode_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключать режим письма между горизонтальным и вертикальным`)
};

const es_writing_mode_aria_label = /** @type {(inputs: Writing_Mode_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar el modo de escritura entre horizontal y vertical`)
};

const zh_cn2_writing_mode_aria_label = /** @type {(inputs: Writing_Mode_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换横向和纵向书写模式`)
};

const ja_writing_mode_aria_label = /** @type {(inputs: Writing_Mode_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`横書きと縦書きを切り替える`)
};

const hi_writing_mode_aria_label = /** @type {(inputs: Writing_Mode_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लेखन मोड को क्षैतिज और ऊर्ध्वाधर के बीच टॉगल करें`)
};

const pt_pt2_writing_mode_aria_label = /** @type {(inputs: Writing_Mode_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar o modo de escrita entre horizontal e vertical`)
};

/**
* | output |
* | --- |
* | "Toggle writing mode between horizontal and vertical" |
*
* @param {Writing_Mode_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const writing_mode_aria_label = /** @type {((inputs?: Writing_Mode_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Writing_Mode_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_writing_mode_aria_label(inputs)
	if (locale === "de") return de_writing_mode_aria_label(inputs)
	if (locale === "it") return it_writing_mode_aria_label(inputs)
	if (locale === "ru") return ru_writing_mode_aria_label(inputs)
	if (locale === "es") return es_writing_mode_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_writing_mode_aria_label(inputs)
	if (locale === "ja") return ja_writing_mode_aria_label(inputs)
	if (locale === "hi") return hi_writing_mode_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_writing_mode_aria_label(inputs)
	return en_writing_mode_aria_label(inputs)
});